// add the fonts that we need for heading and body
import "@fontsource-variable/inter";
import "@fontsource-variable/nunito";
// enable auto resizing in the parent iframe
// https://github.com/davidjbradshaw/iframe-resizer
import "iframe-resizer/js/iframeResizer.contentWindow";
import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import "./index.css";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
